"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyHoldInfoRequest = void 0;
var MyHoldInfoRequest = /** @class */ (function () {
    function MyHoldInfoRequest() {
    }
    return MyHoldInfoRequest;
}());
exports.MyHoldInfoRequest = MyHoldInfoRequest;
;
//# sourceMappingURL=myHoldInfo.request.js.map